import styled from "styled-components";

const StyledHeaderLinkGames = styled.div`
  ul {
    user-select: none;
    li {
      color: black;
      display: flex;

      .item {
        font-size: 14px;
        font-weight: 600;
        color: white;
        text-decoration: none;
        background: linear-gradient(180deg, #fc2e1e 0%, #840b0b 100%);
        padding: 25px 10px 25px 17px;
        border-left: 4px solid white;
        min-width: 217px;
        display: flex;
        position: relative;
      }
      &:hover {
        .item {
          color: #ffdf1b;
          border-left-color: #ffdf1b;
        }
      }
    }
  }
`;
export default StyledHeaderLinkGames;
